<template>
  <v-tooltip top max-width="400">
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" color="orange" v-on="on"
        >mdi-help-circle-outline</v-icon
      >
    </template>
    <span>{{ message }}</span>
  </v-tooltip>
</template>

<script>
import messageApi from "@/common/api/message.api";

export default {
  name: "TooltipViewer",

  props: {
    code: String,
  },

  computed: {
    message() {
      return this.$t(messageApi.getTooltip(this.code));
    },
  },
};
</script>

<style lang="scss" scoped></style>
